import { render } from "./ProgressBarLoader.vue?vue&type=template&id=27dfe7a4&scoped=true"
const script = {}

import "./ProgressBarLoader.vue?vue&type=style&index=0&id=27dfe7a4&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dfe7a4"]])

export default __exports__